export const csrf = () => {
  return document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content');
}
